

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoSepaMandate', function () {
    return {
        template: _template2['default'],
        scope: {
            token: '=?',
            sepa: '=?',
            parentCallbacks: '=?'
        },
        controller: ['$scope', function ($scope) {
            $('body').addClass('pageSepaMandateContingency');
            $scope.$on('$destroy', function () {
                $('body').removeClass('pageSepaMandateContingency');
            });
            $scope.onSubmit = function () {
                $scope.parentCallbacks.sepaAccept();
            };
        }]
    };
});


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-wallet-components/src/member-sepa/sepaMandate/directive.js
// module id = ../node_modules/xo-wallet-components/src/member-sepa/sepaMandate/directive.js
// module chunks = 0